import { combineReducers } from 'redux';
import {
  SETTING_EMAIL_SET_PROFILE,
  SETTING_EMAIL_SHOW_RECIPIENT_MODAL,
  SETTING_EMAIL_HIDE_RECIPIENT_MODAL,
  SETTING_EMAIL_SET_PREVIOUS_EMAIL_NOTIFICATION_FORM,
  SETTING_EMAIL_SHOW_SETTING_ALERT_RECIPIENTS_ERRORS,
  SETTING_EMAIL_HIDE_SETTING_ALERT_RECIPIENTS_ERRORS,
  SETTING_EMAIL_SHOW_DELETE_RECIPIENT_MODAL,
  SETTING_EMAIL_HIDE_DELETE_RECIPIENT_MODAL,
  SETTING_EMAIL_SET_DELETED_RECIPIENT,
  SETTING_EMAIL_SET_BUSINESS_SETTINGS,
} from 'actions/setting/emailNotification/constants';
import createReducer from 'utils/createReducer';

const deletedRecipient = createReducer(null, {
  [SETTING_EMAIL_SET_DELETED_RECIPIENT]: (draft, { payload }) =>
    payload.deletedRecipient,
});

const previousEmailNotificationForm = createReducer(
  {},
  {
    [SETTING_EMAIL_SET_PREVIOUS_EMAIL_NOTIFICATION_FORM]: (
      draft,
      { payload }
    ) => payload.previousEmailNotificationForm,
  }
);

const profile = createReducer(null, {
  [SETTING_EMAIL_SET_PROFILE]: (draft, { payload }) => payload.profile,
});

const businessSettings = createReducer(null, {
  [SETTING_EMAIL_SET_BUSINESS_SETTINGS]: (draft, { payload }) =>
    payload.settings,
});

const showDeleteRecipientModal = createReducer(false, {
  [SETTING_EMAIL_SHOW_DELETE_RECIPIENT_MODAL]: () => true,
  [SETTING_EMAIL_HIDE_DELETE_RECIPIENT_MODAL]: () => false,
});

const showRecipientModal = createReducer(false, {
  [SETTING_EMAIL_SHOW_RECIPIENT_MODAL]: () => true,
  [SETTING_EMAIL_HIDE_RECIPIENT_MODAL]: () => false,
});

const showSettingAlertRecipientsErrors = createReducer(false, {
  [SETTING_EMAIL_SHOW_SETTING_ALERT_RECIPIENTS_ERRORS]: () => true,
  [SETTING_EMAIL_HIDE_SETTING_ALERT_RECIPIENTS_ERRORS]: () => false,
});

export default combineReducers({
  deletedRecipient,
  previousEmailNotificationForm,
  profile,
  businessSettings,
  showDeleteRecipientModal,
  showRecipientModal,
  showSettingAlertRecipientsErrors,
});
